import React from "react";
// useTranslation might not be needed here anymore if all text is in DeviceRow
// import { useTranslation } from "react-i18next"; 
import { useSelector } from "react-redux";
import { cn } from "@/lib/utils";
import DeviceRow from "./DeviceRow.component"; // This is now effectively DeviceCard

export default function ListOfDevices({ ...props }) {
  const devices = useSelector((state) => state.assets.devices);
  // const { t } = useTranslation(); // Might not be needed

  return (
    <div 
      // Removed bg-blue-900, added padding for spacing between cards and container edge
      className={cn(
        "w-full transition-all duration-200 ease-in-out p-2" 
      )}
      {...props}
    >
      {/* Removed sticky header as it's not suitable for card layout */}

      {devices.length > 0 ? (
        devices.map((device) => (
          <DeviceRow // This will render the new card design
            key={device.deviceId}
            device={device}
          />
        ))
      ) : (
        <div className="text-center py-10 text-gray-500">
          <p className="text-lg font-semibold">No devices to display.</p>
          <p>Once devices are added, they will appear here.</p>
        </div>
      )}
    </div>
  );
} 